import { render, staticRenderFns } from "./ReturnOrder.vue?vue&type=template&id=24c904c0&"
import script from "./ReturnOrder.vue?vue&type=script&lang=js&"
export * from "./ReturnOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports